const bankOne = [
    {
      id: 1,
      triggerKey: "Q",
      clipName: "Heater-1",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3"
    },
    {
      id: 2,
      triggerKey: "W",
      clipName: "Heater-2",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3"
    },
    {
      id: 3,
      triggerKey: "E",
      clipName: "Heater-3",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3"
    },
    {
      id: 4,
      triggerKey: "A",
      clipName: "Heater-4",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3"
    },
    {
      id: 5,
      triggerKey: "S",
      clipName: "Clap",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3"
    },
    {
      id: 6,
      triggerKey: "D",
      clipName: "Open-HH",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3"
    },
    {
      id: 7,
      triggerKey: "Z",
      clipName: "Kick-n'-Hat",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3"
    },
    {
      id: 8,
      triggerKey: "X",
      clipName: "Kick",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3"
    },
    {
      id: 9,
      triggerKey: "C",
      clipName: "Closed-HH",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3"
    }
  ];

  export default bankOne;